import { useProgramPathPrepender } from './use-program-path-prepender';

export function usePrependProgramPath(url: string) {
  const getProgramUrl = useProgramPathPrepender();
  return getProgramUrl(url);
}
